import React from "react";

type ButtonClickEvent = React.MouseEvent<HTMLButtonElement> | React.SyntheticEvent<HTMLAnchorElement>;

type ToggleExpanded = () => void;

export interface InjectedCanExpandProps {
    expanded: boolean;
    toggleExpanded: ToggleExpanded;
}

export const canExpand = <P extends InjectedCanExpandProps>(
    WrappedComponent: React.ComponentType<P>,
) => {
    type Props = Pick<P, Exclude<keyof P, keyof InjectedCanExpandProps>>;

    interface State {
        expanded: boolean;
    }

    return class ExpandableComponent extends React.Component<Props, State> {
        constructor(props: Props) {
            super(props);

            this.state = { expanded: false };
            this.toggleExpanded = this.toggleExpanded.bind(this);
        }

        private toggleExpanded(): void {
            this.setState({
                expanded: !this.state.expanded,
            });
        }

        public render() {
            return (
                <WrappedComponent
                    {...this.props as P}
                    expanded={this.state.expanded}
                    toggleExpanded={this.toggleExpanded}
                />
            );
        }
    };
};
